import { useState, useEffect, useCallback, DependencyList } from 'react';

const useFetch = <T>(
  fetchFunction: () => Promise<T>,
  dependencies: DependencyList = [],
) => {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async() => {
    setIsLoading(true);
    setError(null);
    setData(null);
    try {
      const response = await fetchFunction();
      setData(response);
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('An error occurred.');
      }
    } finally {
      setIsLoading(false);
    }
  }, dependencies);

  useEffect(() => {
    fetchData().then();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
};

export default useFetch;
